export const ProductConsts = {
    NUMBER_PATTERN: /^-?\d+$/,
    LISTING_TITLE: 'World of Sweets - Product Listing',
    PRODUCT_DETAIL_PAGE_TITLE: 'World of Sweets - Product Detail',
    SUGGESTED_PAGE_TITLE: 'World of Sweets - Suggested Products',
};


export const SELECTED_FILTER_VALUE:any={
      selectedPmpProductValue:'',
      promotionSelected:'',
      brandSelected:'',
      rspMinValue:0.00,
      rspMaxValue:0.00
  }

export const FILTER_INITIAL_STATE:any={
    "price_marked": '',
    "rsp_min": '', 
    'rsp_max': '',
    "promotion_filter": '', 
    "brand_filter": '',
    "range":''
  }

export const FILTER_TAG_NAME_STATE:any={
    'pmpTagName':'',
    'brandTagName':'',
    'promotionTagName':''
}

export const PMP_PRODUCT_ARRAY : Array<any> =[
    { id: 0, name: 'All Products' },
    { id: 1, name: 'PMP Only' },
    { id: 2, name: 'Non PMP Only' }
  ]